import { render, staticRenderFns } from "./BookNoteMain.vue?vue&type=template&id=26cf5370&scoped=true&"
import script from "./BookNoteMain.vue?vue&type=script&lang=js&"
export * from "./BookNoteMain.vue?vue&type=script&lang=js&"
import style0 from "./BookNoteMain.vue?vue&type=style&index=0&id=26cf5370&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cf5370",
  null
  
)

export default component.exports